import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDesignationApi,
  saveDesignationApi,
  deleteDesignationApi,
} from "../../apiservice/hrpayroll";

export const fetchDesignationsList = createAsyncThunk(
  "designations/fetchDesignationsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDesignationApi(null);
      // Normalize to match form keys
      return response.data.map((d) => ({
        designation_id: d.id,
        designation_name: d.name,
      }));
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOrUpdateDesignation = createAsyncThunk(
  "designations/createOrUpdateDesignation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await saveDesignationApi({
        designation_id: payload.designation_id,
        designation_name: payload.designation_name,
        name: payload.designation_name, // in case backend still expects `name`
        action: payload.action,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteDesignation = createAsyncThunk(
  "designations/deleteDesignation",
  async (designation_id, { rejectWithValue }) => {
    try {
      const response = await deleteDesignationApi({ designation_id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
